import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import {
  ProcessingQueueLookupRequest,
  ProcessingQueueLookupResponse
} from '../models/processing-queue.models';
import { environment } from '../../environments/environment';
import { Brand, SizeGroup, SizeType } from '../models/import-size-data.models';

@Injectable({
  providedIn: 'root'
})
export class ImportSizeDataService {
  constructor(private api: ApiService) {}
  private baseUrl = environment.apiUrl;

  getSizeGroups(): Observable<SizeGroup[]> {
    return this.api.get<SizeGroup[]>(`${this.baseUrl}/import/sizegroups`);
  }

  getSizeTypes(): Observable<SizeType[]> {
    return this.api.get<SizeType[]>(`${this.baseUrl}/import/sizetypes`);
  }

  getBrands(): Observable<Brand[]> {
    return this.api.get<Brand[]>(`${this.baseUrl}/import/brands`);
  }

  startSizeImport(data: FormData): Observable<any> {
    return this.api.postWithFile<any>(`${this.baseUrl}/import/startsizeimport`, data);
  }

  validateSizeImport(data: FormData): Observable<any> {
    return this.api.postWithFile<any>(`${this.baseUrl}/import/validatesizeimport`, data);
  }

  startSizeGroupImport(data: FormData): Observable<any> {
    return this.api.postWithFile<any>(`${this.baseUrl}/import/startsizegroupimport`, data);
  }

  validateSizeGroupImport(data: FormData): Observable<any> {
    return this.api.postWithFile<any>(`${this.baseUrl}/import/validatesizegroupimport`, data);
  }
}